import styled from 'styled-components'

export { StickyPreviewContainer as Container } from '@/configuration/pages/ConfigurationPage/sharedStyles'

export const PreviewIframe = styled.iframe`
  width: 100%;
  height: 100%;
  min-height: 600px;
  border: none;
  border-radius: ${props => props.theme.primitives.radius.radius3};
  background-color: ${props => props.theme.colors.background.primary};
`
